export const take = <O extends Record<string | number, any>, T extends Record<string | number, any> = Record<string, any>>(
  input: Partial<Record<keyof T, any>>,
  ...keys: Array<keyof T>
): O => {
  return keys.reduce((acc, k): Partial<O> => {
    const v = input[k];
    if (typeof v === 'undefined') {
      return acc;
    }
    return { ...acc, [k]: v };
  }, {}) as O;
};
